import { Button, Modal } from 'semantic-ui-react'
import { useStore } from '../../stores/store'
import { observer } from 'mobx-react-lite';

export type ModalSize = 'mini' | 'tiny' | 'small' | 'large' | 'fullscreen';

export default observer(function ModalContainer() {
    const {modalStore} = useStore();
    const {modal: {open, header, body, showOKButton, size}, modal2: {open2, body2}, closeModal, closeModal2} = modalStore;

    return (
      <Modal className='modal-container' closeIcon open={open} onClose={closeModal} size={size as ModalSize}>
          {header !== '' && <Modal.Header>{header}</Modal.Header>}
          <Modal.Content>{body}</Modal.Content>
          {showOKButton &&
            <Modal.Actions>
                <Button
                content="OK"
                labelPosition='right'
                icon='checkmark'
                onClick={() => closeModal()}
                positive
                />
            </Modal.Actions>
            }
          <Modal closeIcon open={open2} onClose={closeModal2} size='small'>
              <Modal.Content>{body2}</Modal.Content>
          </Modal>
      </Modal>
    );
})